import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Injectable,
  OnInit,
  signal,
} from '@angular/core'

import { TranslatePipe, TranslateService, TranslateStore } from '@ngx-translate/core'
import { PrimeTemplate } from 'primeng/api'
import { Button } from 'primeng/button'
import { Dialog } from 'primeng/dialog'
import { Ripple } from 'primeng/ripple'

import { LanguageCode } from '@ti/contracts'
import { CheckIconComponent } from '@ti/core/icons/check/check-icon.component'

import { LanguageService } from '../../services/language.service'
import { BaseLangSwitchDialog } from './base'

@Injectable()
class LocalLanguageService extends LanguageService {
  // Disable moment and PrimengNG translations
  protected override initMomentTranslations() {}
  protected override initPrimeNgTranslations() {}
}

@Component({
  selector: 'app-lang-switch-dialog',
  templateUrl: 'lang-switch-dialog.component.html',
  styleUrls: ['lang-switch-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    { provide: LanguageService, useClass: LocalLanguageService },
    TranslateService,
    TranslateStore,
  ],
  imports: [Dialog, CheckIconComponent, Button, Ripple, PrimeTemplate, TranslatePipe],
})
export class LangSwitchDialogComponent extends BaseLangSwitchDialog implements OnInit {
  protected readonly localLanguageService = inject(LanguageService, { self: true })
  protected readonly parentLanguageService = inject(LanguageService, { skipSelf: true })

  protected readonly opened = signal(false)

  public async ngOnInit() {
    await this.localLanguageService.initialize()
    await this.resetSelectedLanguage()
  }

  public open() {
    this.opened.set(true)
  }

  public close() {
    this.opened.set(false)
  }

  protected async resetSelectedLanguage() {
    const currentLanguage = this.parentLanguageService.current()
    if (currentLanguage && currentLanguage !== this.localLanguageService.current()) {
      await this.localLanguageService.selectLanguage(currentLanguage)
    }
  }

  protected async saveSelectedLanguage() {
    const current = this.parentLanguageService.current()
    const selectedLanguage = this.localLanguageService.current()
    if (selectedLanguage && selectedLanguage !== current) {
      await this.parentLanguageService.selectLanguage(selectedLanguage)
    }
    this.close()
  }

  protected readonly LanguageCode = LanguageCode
}
